import Validation from '@core/logic/Validation'
import OtherNeeds from '@master/model/kyc-form/need-analysis/others/OtherNeeds'

export default class OtherNeedsValidation extends Validation {
  validate (otherNeeds: OtherNeeds, belongsTo: string) {
    this.belongsTo = belongsTo
    const { getMessages, ADD, REQUIRE, WHEN } = this.validator()

    ADD(WHEN(otherNeeds.plan, REQUIRE(otherNeeds.planningFor, 'Other Needs requires to indicate planning for.')), ['Needs Analysis Calculation'], ['planningFor'])
    ADD(WHEN(otherNeeds.plan && !this.isEmpty(otherNeeds.planningFor), REQUIRE(otherNeeds.amountNeeded, 'Other Needs requires to indicate amount needed.')), ['Needs Analysis Calculation'], ['amountNeeded'])
    ADD(WHEN(otherNeeds.plan && !this.isEmpty(otherNeeds.planningFor), REQUIRE(otherNeeds.existingBenefits, 'Other Needs requires to specify existing benefits.')), ['Needs Analysis Calculation'], ['existingBenefits'])

    return getMessages()
  }
}
